import { render } from "./CardEntries.vue?vue&type=template&id=12c2944e&scoped=true"
import script from "./CardEntries.vue?vue&type=script&lang=js"
export * from "./CardEntries.vue?vue&type=script&lang=js"

import "./CardEntries.vue?vue&type=style&index=0&id=12c2944e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12c2944e"]])

export default __exports__